"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "canale-monterano": {
    "61c11011": [{
      "hkey": "f8add4be",
      "slug": "canale-monterano",
      "name": "Canale Monterano",
      "primary": true,
      "skipSearch": false
    }],
    "casenove": [{
      "hkey": "f8add4be",
      "slug": "canale-monterano",
      "name": "Canale Monterano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8c47064c": [{
      "hkey": "f8add4be",
      "slug": "canale-monterano",
      "name": "Canale Monterano",
      "primary": true,
      "skipSearch": false
    }],
    "castagno": [{
      "hkey": "f8add4be",
      "slug": "canale-monterano",
      "name": "Canale Monterano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "45a9c5c1": [{
      "hkey": "f8add4be",
      "slug": "canale-monterano",
      "name": "Canale Monterano",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-carraiola": [{
      "hkey": "f8add4be",
      "slug": "canale-monterano",
      "name": "Canale Monterano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9433b8c9": [{
      "hkey": "084067e7",
      "slug": "bagni-di-stigliano",
      "name": "Bagni di Stigliano",
      "primary": true,
      "skipSearch": false
    }],
    "stigliano": [{
      "hkey": "084067e7",
      "slug": "bagni-di-stigliano",
      "name": "Bagni di Stigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;